import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useJourneyVersionDetail } from "@/lib/journeyQueries";
import { JourneyRail } from "../JourneyRail";

/**
 * Master v5 Prompt 17 coach feedback round 1 — read-only open/preview
 * for a historical, already-published Journey version. Renders through
 * the exact same JourneyRail + preview_version_rail() a client's Home
 * would use — never a locally-faked rail, even for a look-back.
 */
export default function JourneyVersionModal({ workspaceId, versionNumber, memberId, onClose }) {
  const { data, isPending, isError } = useJourneyVersionDetail(workspaceId, versionNumber, memberId);

  return (
    <Dialog open={!!versionNumber} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="journey-version-modal">
        <DialogHeader>
          <DialogTitle className="font-serif">Version {versionNumber}</DialogTitle>
        </DialogHeader>
        {isPending ? (
          <p className="text-sm text-ink-soft" data-testid="journey-version-modal-loading">Loading version…</p>
        ) : isError || !data ? (
          <p className="text-sm text-red-600" data-testid="journey-version-modal-error">Couldn't load this version.</p>
        ) : (
          <div className="space-y-6">
            <div>
              <p className="text-xs text-ink-soft uppercase mb-3">Rail as this client would have seen it</p>
              <JourneyRail nodes={data.nodes} testIdPrefix="journey-version-modal-rail" />
            </div>
            <div>
              <p className="text-xs text-ink-soft uppercase mb-2">Stages</p>
              <div className="space-y-1.5" data-testid="journey-version-modal-stages">
                {data.stage_specs.map((s) => (
                  <div key={s.stage_key} className="text-sm text-ink border border-ink/10 rounded-md px-2.5 py-1.5 bg-white/50 flex items-center justify-between">
                    <span>{s.label}{s.is_hidden && <span className="text-ink-soft text-xs ml-1.5">(hidden)</span>}</span>
                    <span className="text-xs text-ink-soft uppercase">{s.layer_key} · {s.track}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
